import EditProjectTitle from '@/micros/shared-create-and-edit-components/grid-areas/main/project-overview/edit-project-title/edit-project-title';
import EditProjectImage from '../../components/edit-project-image/edit-project-image';
import EditProjectDates from '../../components/edit-project-dates/edit-project-dates';
import EditProjectDescription from '../../components/edit-project-description/edit-project-description';
import EditProjectCategory from '../../components/edit-project-category/edit-project-category';
import ProjectSessionsRowGrid from '../../components/project-sessions-row/project-sessions-row-grid';
import EventStats from '../../components/stats-row/event-stats/event-stats';
import { Case, SwitchCase } from '@ui/switch-case/switch-case';
import { EventType } from '@/types/projects.types';
import { useAppSelector } from '@/store/hooks';
import { selectWorkingProjectType } from '@/store/slices/project/selectors';
import TownhallStats from '../../components/stats-row/townhall-stats/townhall-stats';
import WebinarStats from '../../components/stats-row/webinar-stats/webinar-stats';
import ActivityIndicator from '@/micros/shared-create-and-edit-components/grid-areas/main/project-overview/activity-indicator/activity-indicator';
import Container from '@ui/container/container';

const OverviewMultiSession = () => {
  const projectType = useAppSelector(selectWorkingProjectType);

  return (
    <div data-component="OverviewMultiSession">
      <div className="flex-column gap-10">
        <Container
          padding="0 var(--main-content-horizontal-padding) 10px var(--main-content-horizontal-padding)"
          className="flex flex-1 jc-space-between position-relative"
        >
          <EditProjectTitle />
          <ActivityIndicator />
        </Container>
        <Container
          padding="0 var(--main-content-horizontal-padding)"
          className="flex jc-flex-start ai-flex-start gap-24"
        >
          <Container className="flex fd-column gap-16" width="392px">
            <EditProjectImage />
            <SwitchCase input={projectType}>
              <Case value={EventType.Event}>
                <EventStats />
              </Case>
              <Case value={EventType.Webinar}>
                <WebinarStats />
              </Case>
              <Case value={[EventType.Allhands, EventType.Townhall]}>
                <TownhallStats />
              </Case>
            </SwitchCase>
          </Container>

          <div className="flex-1">
            <div className="flex-column gap-24 margin-b-24">
              <EditProjectDates />
              <EditProjectCategory />
              <EditProjectDescription />
            </div>
          </div>
        </Container>

        <ProjectSessionsRowGrid showFilters />
      </div>
    </div>
  );
};

export default OverviewMultiSession;
